<template>
  <div v-if="!isLoading">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h1 class="font-weight-bolder text-primary">Order Tracking</h1>
      </div>
      <div class="bg-white d-flex align-items-center">
        <div class="bg-primary py-1 px-3 text-center">
          <p class="font-weight-bolder m-0 p-0 h5 text-white">Order ID</p>
        </div>
        <div class="py-1 px-3">
          <p class="font-weight-bolder m-0 p-0 h5 text-success">
            {{ order.reference_id }}
          </p>
        </div>
      </div>
    </div>
    <OrderTrackingDetails :order="order" :is-loading="isLoading" />
    <b-container class="text-center">
      <b-button type="button" variant="primary" class="mt-2" :to="{ name: 'tracking' }"
        >Go Back To Tracking</b-button
      >
    </b-container>
  </div>
</template>
<script>
import OrderTrackingDetails from '@/components/OrderTrackingDetails.vue'
import axios from '@axios'

export default {
  name: 'OrderTracking',
  components: {
    OrderTrackingDetails,
  },
  data() {
    return {
      order: [],
      isLoading: false,
    }
  },
  created() {
    this.getOrder()
  },
  methods: {
    async getOrder() {
      this.isLoading = true
      const response = await axios.get(`orders/${this.$route.params.id}`)
      this.order = response.data.data
      this.isLoading = false
    },
  },
}
</script>
